import { X, Film } from "lucide-react";

const IMG_AI = "https://static.prod-images.emergentagent.com/jobs/2f7bdabb-c81c-4f41-9fe2-245fc40e5116/images/29a31706cc0ac2a912bcc16ccf36e1920844ea908a798b70751468125d85eb53.png";
const IMG_UPLOAD = "https://static.prod-images.emergentagent.com/jobs/2f7bdabb-c81c-4f41-9fe2-245fc40e5116/images/efb1cd0cb6c4ac909bdf9bdcef94fa22a1b1d46e2fc5885940798982a4f3b0fb.png";
const IMG_YOU = "https://static.prod-images.emergentagent.com/jobs/2f7bdabb-c81c-4f41-9fe2-245fc40e5116/images/4d50dd2eb70e30b0c06a8c6e28030cbc11b4d9fbe6cbf1bc0ed6136e4f1926cd.png";

const STEPS = [
  { img: IMG_AI, title: "We start with an AI person", body: "Your manual is illustrated with a generated human." },
  { img: IMG_UPLOAD, title: "You upload your photo", body: "One clear, well-lit selfie of your face is all it takes." },
  { img: IMG_YOU, title: "Now it's YOU!", body: "The AI puts your likeness into every step of your manual." },
];

export default function MovieStarHowItWorks({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[96] flex items-end sm:items-center justify-center p-0 sm:p-4"
      style={{ background: "rgba(23,20,38,.62)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
      data-testid="moviestar-how-modal"
    >
      <div
        className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-[24px] relative border-2 border-[#5d8a52] max-h-[92vh] overflow-y-auto"
        style={{ boxShadow: "0 30px 80px -24px rgba(23,20,38,.6)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="moviestar-how-close"
          onClick={onClose}
          className="absolute top-3.5 right-3.5 p-2 rounded-full text-[#9a96ac] hover:bg-[#f1f0f5] transition-colors z-10"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="px-6 pt-6 pb-1">
          <div className="flex items-center gap-2 text-[#5d8a52] font-bold text-sm">
            <Film size={16} /> MOVIESTAR MODE
          </div>
          <h2 className="text-2xl font-extrabold mt-1.5 leading-tight">Be the star of your own how-to</h2>
          <p className="text-[#6b6880] text-sm mt-2 leading-relaxed">
            Upload one clear photo of your face and watch yourself appear in every step of your manual — and the video.
            Here's how it works:
          </p>
        </div>

        <div className="px-6 py-4 space-y-3">
          {STEPS.map(({ img, title, body }, i) => (
            <div key={i} className="flex items-center gap-3 rounded-2xl border border-[#ece9f5] overflow-hidden">
              <img src={img} alt={title} className="w-24 h-24 object-cover shrink-0" />
              <div className="pr-3 py-2">
                <div className="font-bold text-sm text-[#171426]">{i + 1}. {title}</div>
                <div className="text-xs text-[#6b6880] leading-snug mt-0.5">{body}</div>
              </div>
            </div>
          ))}
          <p className="text-[11px] text-[#9a96ac] leading-snug pt-1">
            Your photo is used once to create the manual and never stored. Because this is AI, results are a stylized
            approximation and won't be a perfect match. For yourself or an adult who has given permission — never minors.
          </p>
        </div>

        <div className="px-6 pb-6">
          <button
            data-testid="moviestar-how-done"
            onClick={onClose}
            className="w-full py-3 rounded-2xl font-bold text-white bg-[#4f7746] hover:bg-[#3f6238] transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
